import { getBrandLogo, getBrandColor } from '../../utils/brandHelpers';

type ProgramBadge = {
    branding: string;
    label: string;
};

type ProgramBadgesProps = {
    badges: ProgramBadge[];
    className?: string;
};

export function ProgramBadges({ badges, className }: ProgramBadgesProps) {
    if (!badges.length) return null;

    return (
        <div className={`flex flex-wrap items-center gap-x-1 leading-5 ${className ?? ''}`}>
            {badges.map((badge, i) => (
                <span key={`${badge.branding}-${badge.label}`} className="inline-flex items-center whitespace-nowrap">
                    {getBrandLogo(badge.branding) && (
                        <img src={getBrandLogo(badge.branding)!} alt="" className="me-1 h-3.5" />
                    )}
                    <span className="text-base font-semibold" style={{ color: getBrandColor(badge.branding) }}>
                        {badge.label}
                    </span>
                    {i < badges.length - 1 && <span className="ms-1 text-slate-grey">·</span>}
                </span>
            ))}
        </div>
    );
}
